module.exports = __webpack_public_path__ + "img/Jump Casting58.13975fa1.jpg";